import { useReducer } from "react";
//#region src/hooks/useToggle.ts
function useToggle(initialValue = false) {
	return useReducer((state) => !state, initialValue);
}
//#endregion
export { useToggle };

//# sourceMappingURL=useToggle.js.map